// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './pages/Layout';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Messages from './pages/Messages';
import LeaveApplication from './pages/LeaveApplication';
import Settings from './pages/Settings';
import TimesheetsPage from './pages/TimesheetsPage';
import CalendarPage from './pages/CalendarPage';
import UserManagement from './pages/UserManagement';
import ReportingPage from './pages/ReportingPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import WorkstreamPage from './pages/WorkstreamPage';
import AssetManagerPage from './pages/AssetManagerPage';

// Department Pages
import MarketingDepartmentPage from './pages/MarketingDepartmentPage';
import ITDepartmentPage from './pages/ITDepartmentPage';
import HRDepartmentPage from './pages/HRDepartmentPage';

const ProtectedRoute = ({ children, allowedRoles = ['employee', 'admin', 'developer'] }) => {
  const token = localStorage.getItem('token');
  const roleId = parseInt(localStorage.getItem('role_id')) || 0;

  const isAdmin = [1, 2].includes(roleId);
  const isDeveloper = roleId === 3;

  if (!token) return <Navigate to="/login" replace />;

  const hasPermission = () => {
    if (isDeveloper) return true;
    if (isAdmin) return allowedRoles.includes('admin');
    return allowedRoles.includes('employee');
  };

  if (!hasPermission()) return <Navigate to="/dashboard" replace />;

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/" element={
          localStorage.getItem('token') 
            ? <Navigate to="/dashboard" replace /> 
            : <Navigate to="/login" replace />
        } />

        <Route element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />

          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/timesheets" element={<ProtectedRoute><TimesheetsPage /></ProtectedRoute>} />
          <Route path="/workstream" element={<ProtectedRoute><WorkstreamPage /></ProtectedRoute>} />
          <Route path="/asset-manager" element={<ProtectedRoute allowedRoles={['admin', 'developer']}><AssetManagerPage /></ProtectedRoute>} />
          <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/leave" element={<ProtectedRoute><LeaveApplication /></ProtectedRoute>} />

          <Route path="/Reporting" element={<ProtectedRoute allowedRoles={['admin', 'developer']}><ReportingPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute allowedRoles={['admin', 'developer']}><Settings /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute allowedRoles={['admin', 'developer']}><UserManagement /></ProtectedRoute>} />

          {/* Department Routes */}
          <Route path="/departments/marketing" element={<ProtectedRoute allowedRoles={['admin', 'developer']}><MarketingDepartmentPage /></ProtectedRoute>} />
          <Route path="/departments/it" element={<ProtectedRoute allowedRoles={['admin', 'developer']}><ITDepartmentPage /></ProtectedRoute>} />
          <Route path="/departments/hr" element={<ProtectedRoute allowedRoles={['admin', 'developer']}><HRDepartmentPage /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;